import { Form } from "antd";

import type { ProductProfileProductEntity } from "src/app/features/ProductProfile/types/subTypes/ProductProfileProductEntity";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { ProductProfileProductsTable } from "./ProductProfileProductsTable";

export const ProductProfileProductsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => (
                <Form.Item key={`${field.name}FormItem`} name={field.name}>
                    <ProductProfileProductsTable
                        key={field.name}
                        readOnly={readOnly}
                        value={getFieldValue(field.name) as ProductProfileProductEntity[]}
                        onChange={(data) => data}
                    />
                </Form.Item>
            )}
        </Form.Item>
    );
};
